export type MascotNeeds = {
  satiety: number
  cleanliness: number
  energy: number
  joy: number
  health: number
}

export type MascotExpression = 'happy' | 'sleepy' | 'sad' | 'tickled' | 'yawning'

// Visual intensities only; the game remains responsible for need progression.
const lack = (value: number | undefined, threshold: number) =>
  value !== undefined && Number.isFinite(value)
    ? Math.max(0, Math.min(1, (threshold - value) / threshold))
    : 0

export function mascotAppearance(
  needs?: Partial<MascotNeeds>,
  expression: MascotExpression = 'happy'
) {
  const hunger = lack(needs?.satiety, 75)
  const dirt = lack(needs?.cleanliness, 85)
  const fatigue = lack(needs?.energy, 75)
  const sadness = Math.max(lack(needs?.joy, 75), expression === 'sad' ? 0.8 : 0)
  const sickness = lack(needs?.health, 80)
  const sleeping = expression === 'sleepy'
  const yawning = expression === 'yawning'
  const delighted = expression === 'tickled' && !sleeping
  const concern = delighted ? 0 : Math.max(hunger * 0.9, sadness, sickness)
  const mood = sleeping
    ? 'sleeping'
    : delighted
      ? 'delighted'
      : sickness > 0.35
        ? 'sick'
        : fatigue > 0.45
          ? 'tired'
          : hunger > 0.3 && hunger >= sadness
            ? 'hungry'
            : sadness > 0.3
              ? 'sad'
              : 'happy'
  const descriptions = [
    yawning ? 'bocejando depois de acordar' : '',
    sleeping ? 'dormindo tranquilamente' : delighted ? 'feliz com seu carinho' : '',
    hunger > 0.3 ? 'com fome' : '',
    dirt > 0.3 ? 'com o pelo sujinho' : '',
    fatigue > 0.3 && !sleeping ? 'cansadinho' : '',
    sadness > 0.3 ? 'sentindo falta de brincar' : '',
    sickness > 0.3 ? 'precisando de cuidados de saúde' : '',
  ].filter(Boolean)
  return {
    hunger,
    dirt,
    fatigue,
    sadness,
    sickness,
    sleeping,
    yawning,
    delighted,
    concern,
    mood,
    description: descriptions.join(', ') || 'feliz e bem cuidado',
  }
}

export type MascotAppearance = ReturnType<typeof mascotAppearance>
